import SeoPageLayout from "@/components/SeoPageLayout";

const WystepKabaretowyBialystok = () => (
  <SeoPageLayout title="Występ kabaretowy Białystok - humor na najwyższym poziomie">
    <p>
      Białystok, stolica Podlasia, to miasto otwarte na kulturę i rozrywkę. Występ kabaretowy w Białymstoku to sprawdzony sposób na urozmaicenie każdego wydarzenia firmowego - od kameralnego spotkania po wielką galę.
    </p>

    <h2 className="text-2xl font-bold text-foreground mt-10">Kabaret na event firmowy w Białymstoku</h2>
    <p>
      Przyjeżdżamy do Białegostoku z profesjonalnym programem kabaretowym dopasowanym do Twojego wydarzenia. Występujemy w hotelach, centrach konferencyjnych i restauracjach na terenie całego miasta i okolic. Materiał zawsze dostosowujemy do branży i charakteru imprezy.
    </p>

    <h2 className="text-2xl font-bold text-foreground mt-10">Gdzie występujemy w Białymstoku?</h2>
    <ul className="list-disc pl-6 space-y-2">
      <li>Hotele w centrum miasta - idealne na gale i bankiety</li>
      <li>Centra konferencyjne - profesjonalna infrastruktura eventowa</li>
      <li>Restauracje i sale bankietowe - kameralne spotkania firmowe</li>
      <li>Obiekty w okolicach Białegostoku - eventy plenerowe i integracyjne</li>
    </ul>

    <h2 className="text-2xl font-bold text-foreground mt-10">Profesjonalny kabaret dla firm z Podlasia</h2>
    <p>
      Firmy z Białegostoku i całego Podlasia mogą liczyć na profesjonalną obsługę kabaretową. Zapewniamy pełen serwis - od dopasowania programu, przez obsługę techniczną, po prowadzenie wieczoru. Każdy występ to gwarancja śmiechu i doskonałej zabawy.
    </p>
  </SeoPageLayout>
);

export default WystepKabaretowyBialystok;
